import React from "react";

export const VisibilityIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_10031_38003)">
          <path
            d="M18.6773 9.73915C16.8051 6.27804 13.5217 4.18359 9.88841 4.18359C6.25508 4.18359 2.96619 6.27804 1.11063 9.73915L0.955078 10.0003L1.09952 10.2669C2.97174 13.728 6.25508 15.8225 9.88841 15.8225C13.5217 15.8225 16.8106 13.7558 18.6773 10.2669L18.8217 10.0003L18.6773 9.73915ZM9.88841 14.6836C6.76063 14.6836 3.88841 12.9391 2.22174 10.0003C3.88841 7.06137 6.76063 5.31693 9.88841 5.31693C13.0162 5.31693 15.8551 7.06693 17.5495 10.0003C15.8551 12.9391 13.0106 14.6836 9.88841 14.6836Z"
            fill="#231F20"
            style={{
              fill: "#231F20",
              fill: "color(display-p3 0.1373 0.1216 0.1255)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M10.0499 6.20518C9.29663 6.21068 8.56189 6.43928 7.93847 6.86211C7.31505 7.28495 6.83091 7.88305 6.54721 8.58087C6.26352 9.27869 6.19298 10.0449 6.34451 10.7828C6.49604 11.5207 6.86284 12.1972 7.39859 12.7267C7.93433 13.2562 8.615 13.6151 9.3546 13.7581C10.0942 13.901 10.8596 13.8215 11.554 13.5297C12.2485 13.2379 12.8409 12.7469 13.2565 12.1186C13.672 11.4903 13.8921 10.7529 13.8888 9.99962C13.8866 9.4982 13.7855 9.00213 13.5913 8.53986C13.397 8.07758 13.1135 7.65818 12.7568 7.30568C12.4002 6.95319 11.9775 6.67453 11.513 6.48569C11.0485 6.29684 10.5513 6.20152 10.0499 6.20518ZM10.0499 12.7163C9.51782 12.7108 8.99922 12.5482 8.55924 12.249C8.11926 11.9497 7.77751 11.5271 7.57692 11.0343C7.37633 10.5414 7.32584 10.0003 7.4318 9.47882C7.53775 8.95736 7.79542 8.47884 8.17244 8.10335C8.54947 7.72786 9.02904 7.47215 9.55092 7.36833C10.0728 7.2645 10.6137 7.3172 11.1058 7.5198C11.5978 7.7224 12.019 8.06587 12.3164 8.50707C12.6139 8.94827 12.7744 9.46753 12.7777 9.99962C12.7792 10.3577 12.7095 10.7126 12.5728 11.0436C12.4361 11.3746 12.2351 11.6751 11.9814 11.9278C11.7276 12.1806 11.4262 12.3804 11.0947 12.5157C10.7631 12.6511 10.408 12.7192 10.0499 12.7163Z"
            fill="#231F20"
            style={{
              fill: "#231F20",
              fill: "color(display-p3 0.1373 0.1216 0.1255)",
              fillOpacity: 1,
            }}
          />
        </g>
        <defs>
          <clipPath id="clip0_10031_38003">
            <rect
              width="20"
              height="20"
              fill="white"
              style={{ fill: "white", fillOpacity: 1 }}
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
